export default __webpack_public_path__ + "static/media/open-app-qr.d7c558c8.jpg";